import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className=" d-flex flex-column gap-0 text-center">
        <img
          src="404 Page not Found.png"
          alt="404 Not Found Illustration"
          className="mx-auto mt-8 w-1/2"
          style={{width: "30vw"}}
        />
        <a href="/" className="btn btn-primary mx-auto mb-8">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
